import { Group, Text } from "@mantine/core";

import { getLastQuarter } from "@utils/dateValidation";

import { ROLES } from "@constants/index";

import FrFlag from "@assets/icons/fr.svg?react";
import EnFlag from "@assets/icons/gb.svg?react";

import i18n from "../i18n";

//* NB: Using functions so that i18n doesn't invoke the "t" function immediately

export const getGenderValues = () => [
  { label: i18n.t("male"), value: "male" },
  { label: i18n.t("female"), value: "female" },
];

export const getDietValues = () => [
  { label: i18n.t("good"), value: "good" },
  { label: i18n.t("moderate"), value: "moderate" },
  { label: i18n.t("bad"), value: "bad" },
];

export const getSmokingHabitsValues = () => [
  { label: i18n.t("daily"), value: "daily" },
  { label: i18n.t("weekly"), value: "weekly" },
  { label: i18n.t("monthly"), value: "monthly" },
  { label: i18n.t("rarely"), value: "rarely" },
  { label: i18n.t("never"), value: "never" },
];

export const bloodTypeValues = [
  "A+",
  "A-",
  "B+",
  "B-",
  "O+",
  "O-",
  "AB+",
  "AB-",
];

export const insuranceTypeValues = ["N/A", "A", "B", "C", "D", "E"];

export const getPaymentMethods = () => [
  {
    label: i18n.t("cash"),
    value: "cash",
  },
  {
    label: "Wave mobile money",
    value: "wave mobile money",
  },
  {
    label: "MTN mobile money",
    value: "mtn mobile money",
  },
  {
    label: "Orange mobile money",
    value: "orange mobile money",
  },
  {
    label: i18n.t("card"),
    value: "card",
  },
  {
    label: i18n.t("other"),
    value: "other",
  },
];

export const getFileTagsValues = () => [
  { label: i18n.t("bill"), value: "bill" },
  { label: i18n.t("consultation-report"), value: "report" },
  { label: i18n.t("sick-note"), value: "sicknote" },
  { label: i18n.t("referral"), value: "referral" },
  { label: i18n.t("immunization"), value: "immunization" },
  { label: i18n.t("lab-result"), value: "lab" },
  { label: i18n.t("prescription"), value: "prescription" },
  { label: i18n.t("radiology"), value: "radiology" },
];

export const getAppointmentCategoriesValues = () => [
  { label: i18n.t("teleconsultation"), value: "teleconsultation" },
  { label: i18n.t("homecare"), value: "homecare" },
  { label: i18n.t("lab"), value: "lab" },
];

export const getYesNoValues = () => [
  { label: i18n.t("yes"), value: "yes" },
  { label: i18n.t("no"), value: "no" },
];

export const languageValues = [
  {
    label: (
      <Group gap={5} w={45}>
        <EnFlag style={{ width: 20, height: 20 }} />
        <Text fz={14} fw={500}>
          En
        </Text>
      </Group>
    ),
    value: "en-US",
  },
  {
    label: (
      <Group gap={5} w={45}>
        <FrFlag style={{ width: 20, height: 20 }} />
        <Text fz={14} fw={500}>
          Fr
        </Text>
      </Group>
    ),
    value: "fr",
  },
];

export const getRolesValues = () => [
  { label: i18n.t("admin"), value: ROLES.ADMIN },
  { label: i18n.t("doctor"), value: ROLES.DOCTOR },
  { label: i18n.t("nurse"), value: ROLES.NURSE },
  { label: i18n.t("receptionist"), value: ROLES.RECEPTIONIST },
  // { label: i18n.t("external-tester"), value: ROLES.EXTERNAL_TESTER },
  // { label: i18n.t("internal-tester"), value: ROLES.INTERNAL_TESTER },
];

export const getViewProfileReasons = () => [
  {
    label: i18n.t("administration"),
    value: "administration",
  },
  {
    label: i18n.t("auditing"),
    value: "auditing",
  },
  {
    label: i18n.t("consultation"),
    value: "consultation",
  },
  {
    label: i18n.t("follow-up"),
    value: "follow-up",
  },
  {
    label: i18n.t("other"),
    value: "other",
  },
];

export const getSeverityRatings = () => [
  { label: i18n.t("severity-1"), value: "1" },
  { label: i18n.t("severity-2"), value: "2" },
  { label: i18n.t("severity-3"), value: "3" },
  { label: i18n.t("severity-4"), value: "4" },
  { label: i18n.t("severity-5"), value: "5" },
];

export const getMedicalHistoryStatusValues = () => [
  { label: i18n.t("active"), value: "active" },
  { label: i18n.t("resolved"), value: "resolved" },
];

export const getMedicalHistoryOriginValues = () => [
  { label: i18n.t("family"), value: "family" },
  { label: i18n.t("personal"), value: "personal" },
];

export const getConsultationTypes = () => [
  {
    label: i18n.t("homecare"),
    value: "homecare",
  },
  {
    label: i18n.t("teleconsultation"),
    value: "teleconsultation",
  },
];

//? Add last-month?
export const getDateRanges = () => [
  {
    label: i18n.t("date-ranges.this-week"),
    value: "this-week",
  },
  {
    label: i18n.t("date-ranges.last-x-days", { count: 7 }),
    value: "last-7-days",
  },
  {
    label: i18n.t("date-ranges.last-week"),
    value: "last-week",
  },
  {
    label: i18n.t("date-ranges.last-x-days", { count: 30 }),
    value: "last-30-days",
  },
  {
    label: i18n.t("date-ranges.last-x-days", { count: 90 }),
    value: "last-90-days",
  },
  {
    label: i18n.t("date-ranges.last-quarter", { context: getLastQuarter() }),
    value: "last-quarter",
  },
  {
    label: i18n.t("date-ranges.this-year"),
    value: "this-year",
  },
  {
    label: i18n.t("date-ranges.last-x-months", { count: 12 }),
    value: "last-12-months",
  },
  {
    label: i18n.t("date-ranges.last-calendar-year"),
    value: "last-calendar-year",
  },
  {
    label: i18n.t("date-ranges.custom-range"),
    value: "custom",
  },
  {
    label: i18n.t("date-ranges.all-time"), // todo:  This might not be needed in dashboard, so potentially filter it out
    value: "all-time",
  },
];

export const getClinicFileTypes = () => [
  {
    label: i18n.t("logo"),
    value: "logo",
  },
  {
    label: i18n.t("license"),
    value: "license",
  },
  {
    label: i18n.t("signature"),
    value: "signature",
  },
  {
    label: i18n.t("other"),
    value: "other",
  },
];

export const getPatientNoteCategories = () => [
  {
    label: i18n.t("all"),
    value: "all",
  },
  {
    label: i18n.t("consultation"),
    value: "consultation",
  },
  {
    label: i18n.t("billing"),
    value: "bill",
  },
  {
    label: i18n.t("laboratory"),
    value: "lab",
  },
  {
    label: i18n.t("prescription"),
    value: "prescription",
  },
  {
    label: i18n.t("appointment"),
    value: "appointment",
  },
  {
    label: i18n.t("follow-up"),
    value: "follow_up",
  },
  {
    label: i18n.t("radiology"),
    value: "radiology",
  },
  {
    label: i18n.t("other"),
    value: "other",
  },
];

export const getBillStatuses = () => [
  {
    label: i18n.t("pending"),
    value: "pending",
    disabled: true,
  },
  {
    label: i18n.t("paid"),
    value: "paid",
    disabled: true,
  },
  {
    label: i18n.t("accepted"),
    value: "accepted",
  },
  {
    label: i18n.t("rejected"),
    value: "rejected",
  },
];

export const getLabCategoryValues = () => [
  {
    label: "Bio-analysis",
    value: "bio_analysis",
  },
  {
    label: "Imaging",
    value: "imaging",
  },
];

export const getConsultationServiceCategoryValues = () => [
  {
    label: i18n.t("teleconsultation"),
    value: "teleconsultation",
  },
  {
    label: i18n.t("homecare"),
    value: "homecare",
  },
];

export const getLabsStatuses = () => [
  { label: i18n.t("ordered"), value: "ordered" },
  { label: i18n.t("completed"), value: "completed" },
];
